import React from 'react';

import Results from '../../features/Results/Results';

const Leaderboards = () => (
  <div>
    <h1>Leaderboard</h1>
    <Results />
  </div>
);

export default Leaderboards;
